module.exports = __webpack_public_path__ + "static/media/img12.3f458731.jpg";